import { render, staticRenderFns } from "./Starting.vue?vue&type=template&id=f9f10722"
import script from "./Starting.vue?vue&type=script&lang=js"
export * from "./Starting.vue?vue&type=script&lang=js"
import style0 from "./Starting.vue?vue&type=style&index=0&id=f9f10722&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports